import React from 'react';
import styled from "styled-components";


export const FooterWrapper = styled.footer`
	position: relative;
	/* background-color: var(--secondaryColor); */
	background-repeat: no-repeat;
	background-size: auto;
	background-position: right -220px top 60px;
	
  
	  
	.footer-logo {
		width: 80px;
	}
	.f-logo-wrap {
		display: flex;
		align-items: start;
		justify-content: start;
	}
  
	.footerContain{
		padding-bottom: 40px;
	}
	.footerContain2{
		padding-top: 25px;
  		padding-bottom: 25px;
		padding-left: 0;
		padding-right: 0;
	}

    .footer-row{
        display: flex;
        justify-content: space-between;
        & > div{
          width: fit-content;
        }
    }
	.ministryLogosWrapper{
		display: flex;
		align-items: center;
		
	}
	
	.minLogo{
		border-right: 2px solid var(--bg2);
		padding-left: 16px;
		padding-right: 16px;
		&:last-child{
			padding-right: 0;
			border-right: 0;
		}
	}
	body.rtl &{
		.minLogo{
			border-right: none;
			border-left: 2px solid var(--bg2);
			&:last-child{
				padding-right: 16px;
				border-left: 0;
			}
		}
		.footer-op-company{
			font-family: var(--arBold);
		}
	}
	
	@media (max-width: 991px) {
		.footer-row{
			flex-wrap: wrap;
		}
		.ministryLogosWrapper{
			width: 100% !important;
			margin-top: 20px;
			justify-content: center;
		}
	}

	@media (max-width: 767px) {
		.footer-row{
			.copyright {
				width: 100%;
				margin-top: 20px !important;
			}
			.Social-links{
				margin-top: 15px;
			}
		}
	}
		
		
		 
		
`;
